import { THROWING_STAR_RELOAD_MS, THROWING_STAR_READY_MS, THROWING_STAR_SIZE } from '../../shared/combat/throwingStars';

/** Neutral metal materials and timing for the assassin's physical stars. */
export const THROWING_STAR_VISUALS = {
  bodySize: THROWING_STAR_SIZE,
  spinRadiansPerSecond: 28,
  edgeColor: 0x283442,
  highlightColor: 0xf2f7ff,
  metalColor: 0xb7c9db,
  hubRadiusRatio: 0.18,
  hubInsetRatio: 0.09,
  edgeWidth: 0.9,
  facetAlpha: 0.78,
  trail: { durationMs: 90, width: 2.4, alpha: 0.42, maxPoints: 9 },
  throw: { durationMs: 140, radius: 8, alpha: 0.45 },
  impact: { durationMs: THROWING_STAR_READY_MS, radius: 10, shardLength: 14, shardWidth: 1.5 },
  reload: {
    durationMs: THROWING_STAR_RELOAD_MS,
    centerOffsetX: 52, centerOffsetY: 0,
    radius: 18, stars: 3, starSize: 18, turnsPerSecond: 0.85,
    strokeWidth: 1.4, alpha: 1, ringAlpha: 0.6,
    endScale: 0.85, endAlpha: 0.55,
  },
  ready: { durationMs: THROWING_STAR_READY_MS, radius: 16 },
} as const;

/** Absolute age avoids frame-rate drift and catches up after a dropped frame. */
export function throwingStarRotation(ageMs: number): number {
  return (Math.max(0, ageMs) / 1000 * THROWING_STAR_VISUALS.spinRadiansPerSecond) % (Math.PI * 2);
}
